import React from "react"
import {Button, DatePicker, Form, Icon, Input, Modal, Tooltip, Upload} from "antd";
import {Task} from "../log_components/Task";
import {TaskStatus} from "../log_components/TaskStatus";


const FormItem = Form.Item;

export class AddUpdateTaskForm extends React.Component{
  render(){
    return(
      <Modal title="Job Task" okText="Create Job Task" centered={true} onCancel={this.props.onClose} visible={this.props.visible}
        className="floating-form" destroyOnClose={true} width={"65%"}>
        <Form>
          <div className="row add-job-task">
            <div className="col-sm-4 col-12">
              <FormItem label="Task Name">
                <Task />
              </FormItem>
            </div>
            <div className="col-sm-4 col-12">
              <FormItem label="Task Due Date">
                <DatePicker/>
              </FormItem>
            </div>
            <div className="col-sm-4 col-12">
              <FormItem label="Task Status">
                <TaskStatus/>
              </FormItem>
            </div>
            <div className="col-sm-8 col-12">
              <FormItem label="Task Notes">
                <Input placeholder="Enter Notes" />
              </FormItem>
            </div>
            <div className="col-sm-4 col-12">
              <FormItem label="Task Attachment">
                <Upload>
                  <Button>
                    <Icon type="upload" /> Click to Upload
                  </Button>
                </Upload>
              </FormItem>
            </div>
          </div>
          <div className="row added-job-task header-task">
            <div className="added-job-item">
              <h5>Task Name</h5>
            </div>
            <div className="added-job-item">
              <h5>Due Date</h5>
            </div>
            <div className="added-job-item">
              <h5>Status</h5>
            </div>
            <div className="added-job-item notes">
              <h5>Notes</h5>
            </div>
            <div className="added-job-item">
              <h5>Uploaded File</h5>
            </div>
            <div className="added-job-item">
              <h5>Action</h5>
            </div>
          </div>
          <div className="row added-job-task task-data">
            <div className="added-job-item">
              <p>Demo Task</p>
            </div>
            <div className="added-job-item">
              <p>2019-03-02</p>
            </div>
            <div className="added-job-item">
              <p>Complete</p>
            </div>
            <div className="added-job-item notes">
               <Tooltip placement="top" title="lorem ipsum dolar amet demo notes">
                <p>lorem ipsum dolar amet demo notes ipsum sudo sipum</p>
                <i className="fa fa-info-circle" />
               </Tooltip>
            </div>
            <div className="added-job-item">
              <p>uplodedfile.pdf</p>
            </div>
            <div className="edit-task added-job-item">
              <button className="btn"><i className="fa fa-pencil" /> </button>
              <button className="btn"><i className="fa fa-trash" /> </button>
            </div>
          </div>
          <div className="row added-job-task task-data">
            <div className="added-job-item">
              <p>Demo Task 2</p>
            </div>
            <div className="added-job-item">
              <p>2019-03-02</p>
            </div>
            <div className="added-job-item">
              <p>Pending</p>
            </div>
            <div className="added-job-item notes">
               <Tooltip placement="top" title="lorem ipsum dolar amet demo notes">
                <p>lorem ipsum dolar amet demo notes ipsum sudo sipum</p>
                <i className="fa fa-info-circle" />
               </Tooltip>
            </div>
            <div className="added-job-item">
              <p>uplodedfile.txt</p>
            </div>
            <div className="edit-task added-job-item">
              <button className="btn"><i className="fa fa-pencil" /> </button>
              <button className="btn"><i className="fa fa-trash" /> </button>
            </div>
          </div>
        </Form>
      </Modal>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/crm/project_log/popups/AddUpdateTask.jsx